import { render, staticRenderFns } from "./innerDialogHead.vue?vue&type=template&id=50c0739f&scoped=true"
import script from "./innerDialogHead.vue?vue&type=script&lang=js"
export * from "./innerDialogHead.vue?vue&type=script&lang=js"
import style0 from "./innerDialogHead.vue?vue&type=style&index=0&id=50c0739f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0739f",
  null
  
)

export default component.exports